<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" epub:type="chapter" id="chapter-2" role="doc-chapter">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed"><span class="element-number-term">Chapter</span> <span class="element-number-number">Two</span></h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-2-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-y"><span class="drop-cap">‘Y</span>ou look incredible,’ says Chris.</p>
<p class="subsq">‘You don’t think it’s too much? I could wear my jeans.’</p>
<p class="subsq">‘You look great. I like you in that dress. Although I don’t know why we’re bothering if they can’t even return our vase.’</p>
<p class="subsq">‘They’ve probably had a lot on their plate,’ I say, excusing Sharni.</p>
<p class="subsq">‘It’s been five days. The flowers will be dead by now, surely.’</p>
<p class="subsq">‘I expect they are busy people and just haven’t got around to returning it. I remember being overwhelmed when we moved in here.’</p>
<p class="subsq">‘Why are you making excuses for them?’</p>
<p class="subsq">‘I’m not.’</p>
<p class="subsq">I smile at his reflection in the mirror. He’s wearing a crisp white shirt and a pair of underpants. I laugh at the absurdity. He smells of Aqua De Parma.</p>
<p class="subsq">‘You smell nice,’ I say.</p>
<p class="subsq">He kisses my neck and his hand slides down to cup my breast. I shiver under his touch.</p>
<p class="subsq">‘I’ve just changed,’ I say.</p>
<p class="subsq">‘You can just un-change then,’ he whispers huskily into my ear.</p>
<p class="subsq">‘Kathryn will be here any minute. Besides, Ben …’</p>
<p class="subsq">‘Is happily playing in his pen.’</p>
<p class="subsq">What if Kathryn knocks and we’re both naked or worse still Chris has a tell-tale bulge. What will she think?</p>
<p class="subsq">‘Chris …’ I begin.</p>
<p class="subsq">The dress slides from my shoulders and I shudder.</p>
<p class="subsq">‘Christ Clare, you’re so sexy,’ he moans.</p>
<p class="subsq">The doorbell chimes, making me jump.</p>
<p class="subsq">‘Shit,’ groans Chris.</p>
<p class="subsq">‘I did warn you,’ I smile. ‘She’s always early.’</p>
<p class="subsq">He zips up the dress, kisses me and hurries to the bathroom. The scent of the Aqua De Parma clings to my dress and I find it comforting.</p>
<p class="subsq">‘I’m a bit early,’ says Kathryn, giving me an admiring glance. ‘That’s a gorgeous dress Mrs Ryan.’</p>
<p class="subsq">‘It’s new,’ I say, sounding like a child with a new toy. ‘I’ll get Ben from the bedroom.’</p>
<p class="subsq">I can’t help wondering if Kathryn compares our home to the houses of her other clients, not that I know any of her clients. Chris and I have only lived in Kensington for eighteen months. I don’t really know anyone apart from the staff at the school, and I really only know Helen well.</p>
<p class="subsq">‘You know where everything is?’ I say. ‘And how the TV works?’</p>
<p class="subsq">‘Yes, I remember,’ she smiles.</p>
<p class="subsq">I’m sounding overanxious again.</p>
<p class="subsq">‘I’m going to finish getting ready.’</p>
<p class="subsq">I brush past Chris on the stairs.</p>
<p class="subsq">‘We have to go in ten minutes if we want to be fashionably late,’ he says, tapping me on the bum.</p>
<p class="subsq">I look at myself in the mirror and begin to doubt what I’ve done with my hair. I thought curls would look good but my hair is too fine and it looks flat. There’s no time to spray some dry shampoo into it, and nowhere near enough time to clip it up. I stroke some lipstick across my lips and dab with a tissue. I’ve put too much blusher on. With shaking hands I dab at my cheeks too.</p>
<p class="subsq">‘Clare,’ Chris calls. ‘Are you ready? We should go.’</p>
<p class="subsq">I step into my heels and take one last look in the mirror. I remember that I have no perfume on and quickly spray some Jo Malone Grapefruit on to my throat. Damn it, now it will be too fresh. I grab Ben and hurry down the stairs.</p>
<p class="subsq">Chris fidgets at the front door.</p>
<p class="subsq">‘I don’t know what I’ve done with my handbag,’ I say looking around.</p>
<p class="subsq">‘It’s here Mrs Ryan,’ Kathryn calls.</p>
<p class="subsq">I check that the bottle of diazepam is in there and let out a small sigh of relief.</p>
<p class="subsq">‘You won’t need those,’ Chris says softly.</p>
<p class="subsq">I pretend not to hear him.</p>
<p class="subsq">‘You have our number,’ I say to Kathryn. ‘Don’t hesitate to phone no matter what. Ben’s beaker is in the kitchen. I’ve left some juice out for him.’</p>
<p class="subsq">Chris sighs.</p>
<p class="subsq">‘No worries Mrs Ryan. You both have a good time.’</p>
<p class="subsq">‘Clare,’ Chris says taking my arm.</p>
<p class="subsq">I nod and shrug into my coat. I give Ben one last look and follow Chris out of the house.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-002.vue?34c4c9a3